<div>
  <div class="row">
    <div class="col-12">
      <section class="prize-hero" aria-label="Tonight's prizes">
        <div class="prize-hero__glow" aria-hidden="true"></div>
        <div class="prize-hero__copy">
          <p class="prize-hero__kicker">Live on LootLucky</p>
          <h1 class="prize-hero__title">Tonight's prizes</h1>
        </div>
        <div
          class="prize-stage"
          *ngIf="prizeCards.length">
          <button type="button" class="prize-nav prize-nav--prev" aria-label="Previous prize" (click)="stepCarousel(-1)">‹</button>
          <article
            class="prize-card"
            *ngFor="let card of prizeCards; let i = index; trackBy: trackPrizeCard"
            [ngStyle]="cardStyle(i)"
            [class.prize-card--front]="cardOffset(i) === 0"
            [class.prize-card--far]="isFar(i)"
            role="button"
            tabindex="0"
            [attr.aria-label]="'Open ' + card.name"
            (click)="OpenWebinarSingle(card.webinarId)"
            (keyup.enter)="OpenWebinarSingle(card.webinarId)">
            <img [src]="card.imageUrl" [alt]="card.name" (error)="onPrizeImageError($event)" />
            <div class="prize-card__overlay">
              <span class="prize-card__tag">{{ card.tag }}</span>
              <span class="prize-card__title">{{ card.name }}</span>
            </div>
          </article>
          <button type="button" class="prize-nav prize-nav--next" aria-label="Next prize" (click)="stepCarousel(1)">›</button>
        </div>
        <div class="prize-dots" *ngIf="prizeCards.length > 1">
          <button
            type="button"
            class="prize-dots__item"
            *ngFor="let card of prizeCards; let i = index; trackBy: trackPrizeCard"
            [class.prize-dots__item--active]="i === activeIndex"
            [attr.aria-label]="'Show ' + card.name"
            (click)="goToCard(i)">
          </button>
        </div>
      </section>
    </div>
  </div>

  <section class="rooms-section">
    <p class="rooms-heading">Explore Rooms to Win Big</p>

    <div class="room-grid" [attr.data-count]="webinarRooms.length">
      <article
        class="room-tile"
        *ngFor="let room of webinarRooms; let i = index"
        [style.display]="webinarDivDisplayAllRooms"
        role="link"
        tabindex="0"
        [attr.aria-label]="'Explore ' + room.roomName"
        (click)="OpenWebinar(room)"
        (keyup.enter)="OpenWebinar(room)">
        <div class="room-tile__media">
          <img
            class="room-tile__image"
            [src]="room.imageUrl || 'assets/Images/defaultImage.jpg'"
            [alt]="room.roomName" />
          <div class="room-tile__shine" aria-hidden="true"></div>
        </div>
        <div class="room-tile__body">
          <h2 class="room-tile__name">{{ room.roomName }}</h2>
          <p class="room-tile__desc">{{ roomDescription(room.description) }}</p>
          <span class="room-tile__cta">Explore room</span>
        </div>
      </article>
    </div>

    <aside class="host-invite" *ngIf="showHostInvite">
      <div class="host-invite__orb" aria-hidden="true"></div>
      <p class="host-invite__kicker">Sell it live</p>
      <h2 class="host-invite__title">Want to host a room?</h2>
      <p class="host-invite__copy">
        Run your own live draws, list prizes, and sell to winners. Apply to host — approval is required before you go live.
      </p>
      <a
        class="host-invite__cta"
        role="button"
        tabindex="0"
        (click)="onBecomeHost()"
        (keyup.enter)="onBecomeHost()">Become a host</a>
    </aside>
  </section>

  <div class="row">
    <div class="col-12">
      <div class="home-footer">
        <div class="home-footer__brand">
          <span class="home-footer__eyebrow">A</span>
          <img src="assets/Images/logo_b.png" alt="World of Webinars" class="clswowLogo" />
          <span class="home-footer__eyebrow">Company</span>
        </div>

        <div class="home-social">
          <div class="rectangle-2"></div>
          <p class="home-social__title">Let's be social</p>
          <div class="home-social__icons">
            <a
              class="social-orb social-orb--tiktok"
              href="https://www.tiktok.com/@loot.luckywow?is_from_webapp=1&sender_device=pc"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="TikTok">
              <img src="assets/Images/tiktok_logo.png" alt="" />
            </a>
            <a
              class="social-orb social-orb--facebook"
              href="https://www.facebook.com/profile.php?id=61589931875521"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook">
              <img src="assets/Images/facebook_logo.png" alt="" />
            </a>
            <a
              class="social-orb social-orb--instagram"
              href="https://www.instagram.com/loot.luckywow?igsh=NGxrMGIxNmpiaXRv"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram">
              <img src="assets/Images/instagram_logo.png" alt="" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
